module.exports = __webpack_public_path__ + "static/img/10.5a3c87a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/5/sp/10.png
// module id = xC4E
// module chunks = 0